export const AppName = {
    ACCOUNTING: 'ACCOUNTING',
    MINIPOS: 'MINIPOS',
};
